import { useQueryClient } from "@tanstack/react-query";
import { useBankingPispAuthQuery } from "Api/Mutations/useBankingPispAuth";
import { bankingAuthExpirationKeys } from "Api/Queries/Banks/useGetBankingAuthExpiration";

export const useBankingPispAuth = () => {
  const queryClient = useQueryClient();

  const { mutate, isPending, variables } = useBankingPispAuthQuery({
    onSuccess: ({ url }) => {
      window.location.href = url;

      queryClient.invalidateQueries({
        queryKey: bankingAuthExpirationKeys.all,
      });
    },
  });

  return {
    authorize: mutate,
    isPending,
    selectedEnvironment: variables?.environment,
  };
};
